import { App } from 'models/app';

export const redirectToLoginFromAppDetails = (app: App, appSubscription: string) => {
  const { location } = window;
  return `?webRedirectUrl=${encodeURIComponent(
    `${location.origin}/appmarket/apps/${app.id}`,
  )}&autoInstall=${app.id}&subscriptionId=${appSubscription}`;
};
